<template>
  <b-row style="position:relative">
    <b-col cols="12" ref="terminals">
      <div class="filters-container">
        <div class="d-flex flex-row" v-if="eshop_id && etenant_id">
          <button class="btn refresh btn-sm" @click.prevent="redirect">{{$t('Add terminal')}}</button>
        </div>
        <DropdownColumns v-model="fields" class="customize" />
      </div>
      <b-table
        id="terminals-table"
        :busy.sync="isBusy"
        show-empty
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :hover="true"
        :striped="true"
        stacked="md"
        v-model="copy"
        :items="provider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        @row-clicked="rowClicked"
        tbody-tr-class="tr-pointer"
        v-columns-resizable="{afterResize: columnsWidthChanged}"
      >
        <template v-slot:empty="scope">
          <div class="text-center">{{ $t(scope.emptyText) }}</div>
        </template>

        <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(tax)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(type)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(install_code)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(active)="data">{{ $t(data.label) }}</template>

        <template v-slot:cell(type)="data">
          <span v-if="data.value == 1">{{ $t("Cashier") }}</span>
          <span v-if="data.value == 2">{{ $t("Self Bet") }}</span>
        </template>

        <template v-slot:head(selected)>
          <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
            <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
            <span></span>
          </label>
        </template>
        <template v-slot:cell(selected)="data">
          <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
            <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
            <span></span>
          </label>
        </template>
        <template v-slot:cell(active)="data">
          <span v-if="data.value">{{$t("YES")}}</span>
          <span v-else>{{$t("NO")}}</span>
        </template>
      </b-table>
      <div class="container-fluid">
        <div class="row">
          <div style="white-space:nowrap;" class="my-2">
            <BulkActionSelect
              v-model="bulkAction"
              :options="bulkActionOptions"
              variant="light"
              class="mr-2"
              size="sm"
              v-if="selected.length"
            />
            <b-button
              @click.stop="applySelected()"
              size="sm"
              class="mr-2 refresh"
              variant="light"
              v-if="selected.length"
              :disabled="!bulkAction"
            >{{$t('Apply')}}</b-button>
            <span class="pagination-sep" v-if="selected.length"></span>
            <PaginationSelect
              v-model="perPage"
              :options="paginationOpts"
              variant="brand"
              size="sm"
            />
            <span>
              &nbsp;
              <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                <span slot="end">{{currentPage * perPage}}</span>
                <span slot="total">{{totalRows}}</span>
              </i18n>
            </span>
            <b-button
              size="sm"
              @click.stop="$root.$emit('bv::refresh::table', 'terminals-table')"
              class="ml-2 refresh"
              variant="light"
              :title="$t('Refresh')"
            >
              <i class="icon-refresh"></i>
            </b-button>
          </div>
          <nav class="ml-auto mt-2">
            <b-pagination
              size="md"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
            />
          </nav>
        </div>
      </div>
    </b-col>
    <b-modal id="bv-modal-terminal" hide-footer centered>
      <template slot="modal-title">{{$t('Terminal')}}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <div class="d-block" style="position:relative">
        <b-form @submit.prevent="onAddTerminal" autocomplete="off" ref="terminal">
          <FloatingLabel
            v-model="details.app_id"
            label="App Id"
            size="sm"
            :readonly="true"
            v-if="details.app_id"
          />
          <FloatingLabel v-model="details.name" label="Name" size="sm" />
          <FloatingLabel v-model="details.tax" label="Tax (%)" size="sm" />

          <div class="mb-2 position-relative">
            <div class="multiselect-lbl" v-if="details.type">{{$t('Terminal Type')}}</div>
            <multiselect
              v-model="details.type"
              :options="typeList"
              placeholder="Select type"
              track-by="value"
              label="label"
            ></multiselect>
          </div>

          <FloatingLabel
            v-model="details.install_code"
            label="Install Code"
            size="sm"
            :readonly="true"
            v-if="details.install_code"
          />

          <b-form-group :label="$t('Active')" class="grouping py-2 px-3 mb-3 mt-0">
            <b-form-checkbox
              v-model="details.active"
              :value="true"
              :unchecked-value="false"
            >{{$t('Enable terminal')}}</b-form-checkbox>
          </b-form-group>

          <div style="text-align: right;">
            <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
          </div>
        </b-form>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf, successConf } from "@/shared/notifications";
import PaginationSelect from "@/components/PaginationSelect";
import tableMixin from "@/shared/mixins/table.mixin";
import DropdownColumns from "@/components/DropdownColumns";
import FloatingLabel from "@/components/FloatingLabel";
import Multiselect from "@/components/multiselect-filters";
import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    FloatingLabel,
    Multiselect,
    BulkActionSelect
  },
  name: "terminals",
  props: ["eshop_id", "etenant_id", "shop_name"],
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "terminals",

      bulkAction: null,
      bulkActionOptions: [
        { text: "Activate Terminals", field: "active", value: true },
        { text: "Inactivate Terminals", field: "active", value: false }
      ],

      isBusy: false,
      sortBy: "app_id",
      sortDesc: false,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        { key: "app_id", sortable: true, class: "" },
        { key: "name", sortable: true, class: "" },
        {
          key: "tax",
          label: "Tax (%)",
          sortable: true,
          class: "",
          ignore: true
        },
        { key: "install_code", sortable: true, class: "" },
        { key: "type", sortable: true, class: "" },
        { key: "active", sortable: true, class: "" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,

      filter: null,
      filterField: null,

      details: {
        eid: null,
        eshop_id: null,
        tax: "5",
        app_id: null,
        install_code: null,
        name: null,
        type: { label: "Cashier", value: 1 },
        active: null
      },

      typeList: [
        { label: "Cashier", value: 1 },
        { label: "SelfBet", value: 2 }
      ],

      addMode: true,
      checkAll: false,
      selected: [],
      copy: null
    };
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    }
  },
  mounted() {
    if (this.eshop_id != "0" && this.eshop_id != "") {
      this.$root.$emit("bv::refresh::table", "terminals-table");
    }
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      console.log("modalId", modalId);
      if (modalId == "bv-modal-terminal") {
        this.details.eid = null;
        this.details.eshop_id = this.eshop_id;
        this.details.tax = "5";
        this.details.name = null;
        this.details.app_id = null;
        this.details.install_code = null;
        this.details.active = null;
        this.type = { label: "Cashier", value: 1 };
        this.addMode = true;
      }
    });
  },
  destroyed() {
    this.$root.$off("bv::modal::hide");
  },
  methods: {
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.terminals
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("terminal/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      });
    },
    refresh() {
      this.$root.$emit("bv::refresh::table", "terminals-table");
    },
    onAddTerminal() {
      const loader = this.$loading.open({
        container: this.$refs.terminal
      });

      let apiAction = "terminal/update";
      if (this.addMode) {
        apiAction = "terminal/create";
      }

      const detailsData = {};
      if (this.details.eid) detailsData.eid = this.details.eid;
      detailsData.tax = parseFloat(this.details.tax);
      detailsData.name = this.details.name;
      detailsData.eshop_id = this.eshop_id;
      detailsData.etenant_id = this.etenant_id;
      detailsData.active = this.details.active;

      detailsData.type = 1;
      if (this.details.type) {
        detailsData.type = parseInt(this.details.type.value);
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Terminal updated";
          if (this.addMode && resp.data.id) {
            msg = "Terminal created";
          }
          this.showSuccessNotification(msg);
          this.$root.$emit("bv::refresh::table", "terminals-table");
          this.$bvModal.hide("bv-modal-terminal");
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    rowClicked(item, index, event) {
      if (item.eid) {
        this.$bvModal.show("bv-modal-terminal");
        this.$nextTick(() => {
          this.addMode = false;
          this.details.eshop_id = this.eshop_id;

          const loader = this.$loading.open({
            container: this.$refs.terminal
          });

          this.$store
            .dispatch("terminal/read", item.eid)
            .then(resp => {
              this.details.eid = resp.data.eid;
              this.details.tax = resp.data.tax;
              this.details.name = resp.data.name;
              this.details.app_id = resp.data.app_id;
              this.details.install_code = resp.data.install_code;
              this.details.active = resp.data.active;
              this.details.type = {
                label: resp.data.type == 1 ? "Cashier" : "SelfBet",
                value: resp.data.type
              };
            })
            .catch(err => {
              this.showErrorNotification(err);
            })
            .finally(() => {
              loader.close();
            });
        });
      }
    },
    redirect() {
      if (!this.eshop_id) {
        return;
      }
      this.addMode = true;
      this.details.eshop_id = this.eshop_id;
      this.$bvModal.show("bv-modal-terminal");
    },
    provider(ctx, callback) {
      if (!this.eshop_id) {
        callback([]);
        return;
      }

      const loading = this.$loading.open({
        container: this.$refs.terminals
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
        exactFields: ["shop_id"],
        exactValues: [[this.eshop_id]]
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      this.$store
        .dispatch("terminal/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;
          callback(resp.data.rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


